import Account from '../Account';

class GetCitiesResponse {
  public readonly success: boolean;
  public readonly data: ReadonlyArray<Account>;
  public readonly error: String[];
  public readonly errors: String[];

  constructor(success: boolean, data: Account[], error: String[], errors: String[]) {
    this.success = success;
    this.data = Object.freeze([...data]);
    this.error = error;
    this.errors = errors;
  }

  static fromApiResponse(response: any): GetCitiesResponse {
    const success = response.success ?? false;
    const accounts = response.data?.accounts ? Account.fromApiDataArray(response.data.accounts) : [];
    return new GetCitiesResponse(success, accounts, response.data.error, response.data.errors);
  }
}

export default GetCitiesResponse;
